import DOMPurify from 'dompurify';

import { sanitizeLinkTargetHook, sanitizeSrcHook, sanitizeStyleHook } from './sanitizerHooks';

import type { SanitizerSrcHookOptions, SanitizerStyleHookOptions } from './sanitizerHooks';

/** DOMPurify 기본 allowlist 에 없어 제거되는 속성 중 본문에서 유지해야 하는 것 */
const ADDITIONAL_ALLOWED_ATTRIBUTES = ['target'];

let domPurifyHookAttached = false;

export default function getSanitizedHtml(
  html: string,
  srcOptions?: SanitizerSrcHookOptions,
  styleOptions?: SanitizerStyleHookOptions,
) {
  if (typeof window === 'undefined') {
    return '';
  }

  if (!domPurifyHookAttached) {
    DOMPurify.addHook('beforeSanitizeAttributes', node => sanitizeSrcHook(node, srcOptions));
    DOMPurify.addHook('uponSanitizeAttribute', (node, data) =>
      sanitizeStyleHook(node, data, styleOptions),
    );
    DOMPurify.addHook('afterSanitizeAttributes', sanitizeLinkTargetHook);

    domPurifyHookAttached = true;
  }

  return DOMPurify.sanitize(html, { ADD_ATTR: ADDITIONAL_ALLOWED_ATTRIBUTES });
}
